<div class="celda_white clearfix">
	<div class="left_celda">
		<label>Elija la cuenta de origen:</label>
		<app-select-account
			[items]="accounts"
			[itemSelected]="itemSelected"
			(changeItem)="changeItem()"
			[(ngModel)]="accountSelected"
		></app-select-account>
		<app-valid-message-form
			*ngIf="submit && errorAccount"
			[message]="errorAccount"
			type="error"
		></app-valid-message-form>
	</div>

	<div class="right_celda">
		<!-- <label></label> -->
		<br />
		<app-tag-mount [item]="itemMount"></app-tag-mount>
	</div>
</div>
<div class="celda_white clearfix">
	<div class="center_monto">
		<label>{{ titleInput }} </label>
		<app-input-mount
			[(ngModel)]="mount"
			(change)="changeValue()"
			[symbolCoin]="accountSelected ? accountSelected.symbolCoin : ''"
			[required]="true"
			[errorText]="errorMount"
			[submit]="submit"
		></app-input-mount>
	</div>
</div>
